/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Title_AccentInputs */

const en_portal_view_title_accent = /** @type {(inputs: Portal_View_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the same`)
};

const pl_portal_view_title_accent = /** @type {(inputs: Portal_View_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to samo`)
};

/**
* | output |
* | --- |
* | "the same" |
*
* @param {Portal_View_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_title_accent = /** @type {((inputs?: Portal_View_Title_AccentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Title_AccentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_title_accent(inputs)
	return en_portal_view_title_accent(inputs)
});